import { useTranslation } from 'react-i18next'

import { mergeClassName } from '../../../../utils/mergeClassName'
import { PlaceField, RadioGroup } from '../../../Form'
import AddressFields from '../../../Form/fields/PlaceField/AddressFields'
import { Label, Row, Cell, Field } from '../../../data'
import NbStairsControl from '../../quotesRequest/AddressesForm/NbStairsControl'

type LocationFieldsProps = {
  name: string
  specificAddresses?: boolean
  wide?: boolean
  children?: React.ReactNode
}

const LocationFields: React.FC<LocationFieldsProps> = ({
  name,
  specificAddresses = false,
  wide = false,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <div className={mergeClassName(
      'rounded-md border p-4 shadow lg:border-none',
    )}
    >
      { children && (
        <div className="mb-4">
          <Label className="mb-2">
            { t('components.move.addresses.stopDescription') }
          </Label>
          { children }
        </div>
      ) }
      <Label className="mb-2">
        { children ? t('components.move.addresses.stopAddress') : t('components.move.addresses.address') }
      </Label>

      <Field className="mt-0">
        { specificAddresses
          ? (
            <AddressFields name={`${name}.address`} />
            )
          : (
            <PlaceField name={`${name}.address`} className="mt-0" />
            ) }
      </Field>

      <Row className={mergeClassName(
        'lg:my-0 gap-x-8',
        wide && 'lg:flex-col lg:gap-y-4',
      )}
      >
        <Cell>

          <Label>
            { t('components.move.addresses.nbStairs') }
          </Label>
          <NbStairsControl name={`${name}.nbStairs`} />

        </Cell>

        <Cell>
          <Label>
            { t('components.move.addresses.elevator') }
          </Label>
          <div className="mt-2">
            <RadioGroup
              name={`${name}.elevatorReservationRequired`}
              options={[
                {
                  value: '0',
                  label: (
                    <span className="inline-block py-1">
                      { t('components.move.addresses.elevatorNotNeeded') }
                    </span>
                  ),
                },
                {
                  value: '1',
                  label: (
                    <span className="inline-block py-1">
                      { t('components.move.addresses.elevatorNeeded') }
                    </span>
                  ),
                },
              ]}
            />
          </div>

        </Cell>
      </Row>
    </div>
  )
}

export default LocationFields
